import { ShapeUtil, TLBaseShape, Rectangle2d, HTMLContainer } from 'tldraw'
import ConnectorCard from './ConnectorCard'
import { shapeNodeToSvgImage } from '../utils/shapeNodeToSvgImage'

export type ConnectorCardShape = TLBaseShape<
  'ConnectorCard',
  {
    w: number
    h: number
    documentId?: string
    name?: string
    doc_type?: string
  }
>

export const CONNECTOR_CARD_WIDTH = 300
export const CONNECTOR_CARD_HEIGHT = 100

export class ConnectorCardShapeUtil extends ShapeUtil<ConnectorCardShape> {
  static override type = 'ConnectorCard' as const

  getDefaultProps(): ConnectorCardShape['props'] {
    return {
      w: CONNECTOR_CARD_WIDTH,
      h: CONNECTOR_CARD_HEIGHT,
    }
  }

  getGeometry(shape: ConnectorCardShape) {
    return new Rectangle2d({
      width: shape.props.w,
      height: shape.props.h,
      isFilled: true,
    })
  }

  component(shape: ConnectorCardShape) {
    if (!shape) return

    return (
      <HTMLContainer style={{ pointerEvents: 'all' }}>
        <ConnectorCard id={shape.props?.documentId} />
      </HTMLContainer>
    )
  }

  indicator() {
    return null
  }

  // FS-482: rasterize the live DOM for off-DOM exports. See shapeNodeToSvgImage.
  override toSvg(shape: ConnectorCardShape) {
    return shapeNodeToSvgImage(shape.id, shape.props.w, shape.props.h)
  }
}
